import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../productsPage.css';
import { useNavigate } from 'react-router-dom';
import ProductCategory1 from '../paper-bags/Product-category-section/product-category1';
import ProductCategory2 from '../paper-bags/Product-category-section/product-category2';
// import ProductCategory3 from '../paper-bags/Product-category-section/product-category3';
// import ProductCategory4 from '../paper-bags/Product-category-section/product-category4';
// import ProductCategory5 from '../paper-bags/Product-category-section/product-category5';

const PaperBags = () => {
  const navigate = useNavigate();
  
  return (
    <>
      {/* Added margin classes only for mobile and tablet */}
      <div className="container-fluid bags-container d-flex align-items-center">
        <div className="row justify-content-center w-100">
          <div className="col-12 col-lg-10">
            <div className="card-banner">
              <div className="row g-0">
                {/* Left side with single product image */}
                <div 
                  className="col-md-6 d-flex align-items-center justify-content-center p-5" 
                  
                >
                  <img
                    src="/assets/products-with-logo/paper-bags/paper-bags-large-size.jpg"
                    className="img-fluid"
                    alt="Bag Product"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      objectFit: 'contain'
                    }}
                  />
                </div>
                
                {/* Right side content */}
                <div 
                  className="col-md-6 d-flex align-items-center" 
                >
                  <div className="p-4 p-lg-5 w-100">
                    <small className="text-black text-uppercase letter-spacing-1 mb-2 d-block">
                      Sturdy, practical, sustainable.
                    </small>
                    
                    <h2 className="main-heading display-5 fw-bold text-dark mb-4">
                      Paper Bags
                    </h2>
                    
                    <p className="product-each-desc text-black mb-4 lead">
                      Paper Bags feature a sturdy flat base and pre-creased folds for effortless use, 
                      combining durability and versatility to meet diverse packaging needs. prepare 
                      this kind of matter for paper bags
                    </p>
                    
                    <div className="text-center mb-4">
                      <button 
                        className="btn btn-dark btn-sm rounded-pill text-uppercase mx-auto" 
                        style={{ 
                          width: '100px',
                          fontSize: '0.6rem',
                          padding: '10px 2px',
                          lineHeight: '1.2',
                          display: 'block'
                        }}
                        onClick={() => { navigate('/contact'); }}
                      >
                        Contact Us
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProductCategory1 />
      <ProductCategory2 />
      {/* <ProductCategory3 />
      <ProductCategory4 />
      <ProductCategory5 /> */}
    </>
  );
};

export default PaperBags;